const atob = require('atob')

function check_signature(key, target, signature) {
}


const GlobalMethods = {
  install(Vue, options) {
    Vue.prototype.showNotificationError = (text, title = Vue.Constants.TEXT_NOTIFICATION_ERROR) => {
      Vue.notify({
        group: Vue.Constants.NOTIF_GROUP_COMMON,
        type: 'error',
        title: title,
        text: text,
        duration: Vue.Constants.NOTIF_DURATION_INFINITE,
        speed: Vue.Constants.NOTIF_SPEED_DEFAULT
      })
    },
    Vue.prototype.showNotificationSuccess = (text, duration = Vue.Constants.NOTIF_DURATION_DEFAULT, title = Vue.Constants.TEXT_NOTIFICATION_SUCCESS) => {
      Vue.notify({
        group: Vue.Constants.NOTIF_GROUP_COMMON,
        type: 'success',
        title: title,
        text: text,
        duration: duration,
        speed: Vue.Constants.NOTIF_SPEED_DEFAULT
      })
    },

    Vue.prototype.parseJwt = (token) => {
      var array = token.split('.')
      var header = array[0]
      var payload = array[1]
      var signature = array[2]

      var decodedStringAtoB = atob(header)
      decodedStringAtoB = atob(payload)
      decodedStringAtoB = atob(signature)
    }
  },
}

export default GlobalMethods
